import { createStore } from 'vuex'

export default createStore({
  state: {
    // currentAge: null,
    // annualPayment: null,
    // paymentYears: null,
    // targetAge: null,
    // targetReturnValue: null,
    // targetAge_wd: null,
    // targetReturnValue_wd: null,
    // result: null,
    // result_wd: null,
    // selectedCurrency: null,
    // resultsText_tc: '',
    // resultsText_sc: '',
    // resultsText_tc_wd: '',
    // resultsText_sc_wd: '',
    currentAge: null,
    annualPayment: null,
    paymentYears: null,
    targetAge: null,
    targetReturnValue: null,
    targetAge_wd: null,
    targetReturnValue_wd: null,
    result: null,
    result_wd: null,
    selectedCurrency: 'USD',
    resultsText_tc: '',
    resultsText_sc: '',
    resultsText_tc_wd: '',
    resultsText_sc_wd: '',

    startYear01: null,
    endYear01: null,
    withdrawAmount01: null,
    startYear02: null,
    endYear02: null,
    withdrawAmount02: null,

  },
  mutations: {


    setStartYear01(state, value) {
      state.startYear01 = value
    },

    setStartYear02(state, value) {
      state.startYear02 = value
    },

    setEndYear01(state, value) {
      state.endYear01 = value
    },

    setEndYear02(state, value) {
      state.endYear02 = value
    },

    

    setWithdrawAmount01(state, value) {
      state.withdrawAmount01 = value
    },

    setWithdrawAmount02(state, value) {
      state.withdrawAmount02 = value
    },




    setSelectedCurrency(state, currency) {
      state.selectedCurrency = currency
    },
    setResultsText_tc(state, text) {
      state.resultsText_tc = text
    },
    setResultsText_sc(state, text) {
      state.resultsText_sc = text
    },

    setResultsText_tc_wd(state, text) {
      state.resultsText_tc_wd = text
    },
    setResultsText_sc_wd(state, text) {
      state.resultsText_sc_wd = text
    },

    setCurrentAge(state, age) {
      state.currentAge = age
    },
    setAnnualPayment(state, payment) {
      state.annualPayment = payment
    },
    setPaymentYears(state, years) {
      state.paymentYears = years
    },
    setTargetAge(state, age) {
      state.targetAge = age
    },
    setTargetReturnValue(state, value) {
      state.targetReturnValue = value
    },

    setTargetAge_wd(state, age) {
      state.targetAge_wd = age
    },
    setTargetReturnValue_wd(state, value) {
      state.targetReturnValue_wd = value
    },

    setResult(state, result) {
      state.result = result
    },
    setResult_wd(state, result) {
      state.result_wd = result
    },
  },

  actions: {
    // uploadRecordsAction(context, payload) {
    //   context.commit('uploadRecords', payload)
    // },
  },
})
